<template>
  <div class="mb-5">
    <div
      v-for="article in objectList"
      :key="article.slug"
      class="card"
    >
      <div class="p-4 p-md-5">
        <div class="row">
          <div class="col-md-4 flex justify-content-center align-items-center">
            <img
              :src="article.image || require('@/common/assets/img/logo.png')"
              class="img-lg img img-thumbnail"
              :alt="`image--${article.slug}`"
            />
          </div>
          <div class="col-md-8">
            <router-link
              :to="`/articles/${article.slug}`"
              class="text-dark text-large font-weight-semibold"
            >
              <h2>{{ article.title }}</h2>
            </router-link>
            <div class="d-flex flex-wrap mt-3">
              <div class="mr-3">
                <i class="far fa-calendar-alt text-light"></i>&nbsp;
                {{ toLocalPrettyDateTime(article.created_at) }}
              </div>
            </div>
            <div class="mt-3 mb-4">
              {{ article.summary }}
            </div>
          </div>
        </div>
      </div>
      <hr class="border-light m-0">
    </div>

    <div
      class="m-3 d-flex justify-content-center align-items-center"
      v-if="nextPageUrl"
    >
      <v-button
        v-if="nextPageUrl"
        text="phrase.load_more"
        @click="getObjects(nextPageUrl, true)"
      />
    </div>
  </div>
</template>


<script>
import { toLocalPrettyDateTime } from '@/common/utils/formatting';
import { GenericListMixin } from '@/common/utils/mixins';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import Button from '@/common/components/Button.vue';

export default {
  name: 'ArticleList',
  components: {
    'v-button': Button,
  },
  data() {
    return {
      apiPath: 'public/articles/',
    };
  },
  mixins: [
    GenericListMixin,
  ],
  methods: {
    toLocalPrettyDateTime,
  },
  created() {
    setBreadcrumbs('articleList');
  },
};
</script>
